function UlToc(args) {
    "use strict";

    this.version = "1.0";

    var defargs = {
        debug: false,
        getScrollOffset: function() { return 0; },
        orientation: "vertical",
        outputcontainerid: "",
        ultocid: ""
    };

    $.extend(defargs, args);

    var tocitms = [];
    var lastclicked = "";

    if (defargs.outputcontainerid === null) { throw new Error("Invalid arguments passed to UlToc constructor."); }

    if (defargs.ultocid.length === 0) {
        defargs.ultocid = "ultoc-" + Math.round(1000 * Math.random());
    }
   
    initialize();

    function initialize() {
        if ($(defargs.outputcontainerid).length !== 0) {
            var output = "<ul id='" + defargs.ultocid + "'></ul>";

            $(defargs.outputcontainerid).append(output);

            var elms = $("[data-ultoc-title]").each(function(index) {
                var title = $(this).attr("data-ultoc-title");

                if (title !== undefined) {
                    var tid = "toc-" + index;
                    tocitms.push({ tocitmid: tid, element: this });

                    $(getUlTocID()).append("<li id='" + tid + "'><a href='#' title='" + title + "'>" + title + "</a></li>");

                    var element = this;

                    $("#" + tid).click(function(e) {
                        e.preventDefault();

                        var spos = 0;
                        var soffset = defargs.getScrollOffset();
                        var wndh = $(window).height();
                        var doch = $(document).height();

                        if (defargs.orientation === "vertical") {
                            spos = $(element).offset().top - soffset;
                            if (spos < 0) { spos = 0; }
                            if (spos + wndh > doch) { spos -= ((spos + wndh) - doch); }

                            $(window).off("scroll", scrollHandler);

                            TweenMax.to("html, body", 1, { scrollTop: spos, ease: Quint.easeInOut, onComplete: function () { updateToc(); $(window).on("scroll", scrollHandler); } });
                        }
                        else {
                            wndh = $(window).width();
                            doch = $(document).width();

                            spos = $(element).offset().left - soffset;
                            if (spos < 0) { spos = 0; }
                            if (spos + wndh > doch) { spos -= ((spos + wndh) - doch); }

                            $(window).off("scroll", scrollHandler);

                            TweenMax.to("html, body", 1, { scrollLeft: spos, ease: Quint.easeInOut, onComplete: function () { updateToc(); $(window).on("scroll", scrollHandler); } });
                        }

                        lastclicked = tid;                        
                    });                    
                }
                else { debug("No TOC title specified!"); }
            });

            $(window).scroll(scrollHandler);

            updateToc();            
        }
        else { debug("Output container element ID '" + defargs.outputcontainerid + "' not found!"); }
    }

    function getUlTocID() {
        return "#"+defargs.ultocid;
    }
    
    function updateToc() {
        var wndh = $(window).height();
        var soffset = defargs.getScrollOffset();
        var stp = $(window).scrollTop() + soffset;

        if (defargs.orientation !== "vertical") {
            wndh = $(window).width();
            stp = $(window).scrollLeft();
        }

        var selid = "";

        if (lastclicked.length > 0) {
            selid = lastclicked;
        }

        if (selid.length === 0) {
            var closest = -1;
            var sel = -1;

            for (var x = 0; x < tocitms.length; x++) {
                var elmt = $(tocitms[x].element).offset().top;
                var cur = stp - elmt;
                if (defargs.orientation !== "vertical") { cur = Math.abs(stp - $(tocitms[x].container).offset().left); }

                if (stp + (wndh * 0.5) >= elmt) {
                    if ((cur <= closest || closest === -1)) {
                        closest = cur;
                        sel = x;
                    }
                }
            }

            if (sel > -1) {
                selid = tocitms[sel].tocitmid;
            }
        }

        if (selid.length !== 0) {
            if (!$("#" + selid).hasClass("selected")) {
                $(getUlTocID() + " li").removeClass("selected");

                $("#" + selid).addClass("selected");
            }

            debug("Selected toc item ID: " + selid);

            return true;
        }        

        $(getUlTocID() + " li").removeClass("selected");

        return false;
    }    
   
    function scrollHandler() {
        $(window).off("scroll", scrollHandler);

        lastclicked = "";
        
        setTimeout(function () { updateToc(); $(window).on("scroll", scrollHandler); }, 300);
    }

    function debug(txt) {
        if (defargs.debug) {
            console.log("UlToc - " + txt);
        }
    }

    return this;    
}